/* eslint-disable import/no-anonymous-default-export */
import { Navigate, RouteObject } from "react-router-dom";
import {
  KYC_APPROVAL,
  // KYC_APPROVAL_DETAILS,
  KYC_APPROVAL_OVERVIEW,
} from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: KYC_APPROVAL,
    lazy: () => import("./routes/KycApprovalOverview"),
  },
//   {
//     path: KYC_APPROVAL_OVERVIEW,
//     lazy: () => import("./routes/KycApprovalOverview"),
//   },
  // {
  //   path: KYC_APPROVAL_DETAILS,
  //   lazy: () => import("./routes/KycApprovalDetails"),
  // },
] as RouteObject[];
